module.exports = __webpack_public_path__ + "static/media/OP.6be1c36f.png";